import { useTheme } from "@mui/material/styles";
import { cardColorVariant } from "styles/theme/themes";
import { TypeCalendarScheduleProps } from "./Types";

const useStyleCalendarSchedule = ({ slot }: TypeCalendarScheduleProps) => {
  const theme: any = useTheme();

  return {
    main: {
      overflow: 'auto',
      "&>div": {
        "*": {
          fontFamily: theme.typography.fontFamily,
          // color: theme.palette.text.primary
        },
      },
      ".rbc-header": {
        boxSizing: "border-box",
        button: {
          p: 2,
          boxSizing: "border-box",
        },
        span: {
          color: "#0D062D",
          fontFamily: "Inter",
          fontSize: "18px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "normal",
        },
      },
      ".rbc-calendar": {
        gap: 1,
        pr: 1,

      },
      ".rbc-day-slot .rbc-events-container": {
        mr: 0,
      },
      ".rbc-event:focus, .rbc-day-slot .rbc-background-event:focus": {
        outline: "5px solid " + theme.palette.primary.default,
      },
      ".rbc-event": {
        color: "inherit",
        gap: 1,
        backgroundColor: '#f4f7ff',
        ...cardColorVariant,
      },
      ".rbc-allday-cell": {
        display: "none",
      },
      ".rbc-time-slot": {
        display: "grid",
        alignItems: "center",
      },
      ".rbc-event-label": {
        width: "100%",
        display: "none",
        // wordWrap: "break-word",
        // textOverflow: "unset",
        // whiteSpace: "normal"
      },
      '.rbc-time-view': {
        minWidth: '700px',
      },
      '.rbc-month-view': {
        borderRadius: '1rem !important',
        pt: '0px !important',

      },
      '.rbc-month-header': {
        minHeight: '70px',
        alignItems: 'center',
      },
      '.rbc-month-row': {
        minHeight: '118px',
      },

      [`
        .rbc-month-view,
        .rbc-time-view,
        .rbc-agenda-view
      `]: {
        minWidth: '700px',
        p: 2,
        borderRadius: 2,
        backgroundColor: theme.palette.common.background,
      },
      [`
        .rbc-day-slot .rbc-event,
        .rbc-time-view,
        .rbc-time-header.rbc-overflowing,
        .rbc-header,
        .rbc-timeslot-group, 
        .rbc-day-slot .rbc-time-slot,
        .rbc-day-bg + .rbc-day-bg
      `]: {
        border: "unset",
      },
      ...(slot?.action
        ? {
          display: "grid",
          gridTemplateAreas: {
            xs: '"_header" "_action" "_calendar"',
            sm: '"_header _action" "_calendar _calendar"'
          },
          gridTemplateRows: {xs:"auto auto 1fr", sm: "auto 1fr"},
          gap: { xs: 2, sm: 0 }
        }
        : {}),
    },
    action: {
      gridArea: "_action",
      alignItems: { xs: 'start', sm: "end" },
    },
    calendar: {
      gridArea: "_calendar",
      overflow: 'auto',

    },
    header: {
      gridArea: "_header",
      gap: 1,
      alignItems: "center",
      title: {
        color: "#404040",
        fontFamily: "Inter",
        fontSize: "24px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "normal",
      },
    },
  };
};
export default useStyleCalendarSchedule;
